import { useEffect } from "react";
import { PageControl, KIND } from "baseui/page-control";
import { useNavigate } from 'react-router-dom';
import { Analytics,Gtag } from '../../compornents/Analytics';
import React from 'react';

// サービスの流れ STEP.3/4（bag-first改定 2026-09-01）。
// 改定前は「バッグを依頼→受け取る」の2枚だったが、新動線では
// 「バッグが届く → 入れる → 自分で集荷を依頼する → 届く」の4工程になる。
// 特にSTEP.1で「最初の配達はバッグであって、依頼品はまだ渡せない」ことを
// 注文前から刷り込んでおくのが、この改定で最も重要な役割。
export const RegisterStep3 = () => {
  const navigate = useNavigate();

  const next = () => {
    navigate('/register/step4');
  }

  useEffect(() => {
    Gtag('view_register_step3');
  }, []);

  return (
    <div>
      <div>
        <Analytics title="Step3" />
        <div className="Register">
          <div className="App-step1">
            <div className="App-h1 pt-4">{"STEP.3"}</div>
            <img src="/img/step3.png" alt="アプリから集荷依頼" className="App-img" />
            <div className="App-title-sm">アプリから集荷を依頼</div>
            <div className="App-comment">{"準備ができたらアプリのボタンひとつで集荷依頼。\n配達パートナーがご自宅までお伺いします。"}</div>
            <div className="App-h3">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '20px',
                }}
              >
                <PageControl
                  currentPage={3}
                  numPages={4}
                  kind={KIND.default}
                  aria-label="label"
                />
              </div>
              <button className="button-next-w" onClick={next}>{"次へ"}</button>
              <div><img src="../img/Direct_delivered with_Uber Eats_horiz_pill_green_en_1@2x.png" className="ud_img" alt="ud logo" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
